import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { dropdownOptions, dropdownImages, portfolioImages, slideshowImages, egretFlightImages, egretFamilyImages, egretCourtshipImages, egretChicksImages, piedBilledGrebeImages, divingDucks1Images, divingDucks2Images, oddBuffleheadImages, floatingBuffleheadImages, flightBuffleheadImages, femaleBuffleheadImages, snowyEgretImages, watchingRedTailedHawk, greatBlueHeron, cattleEgretImages, coopersHawkImages, ringneckDucksEclipseImages, egretPreeningImages, scissortailedImages, houseFinchImages, mallardImages } from './images';
import { SHOW_MODAL, DROPDOWN_SELECTION, DROPDOWN_OPEN, SLIDE_SHOW, PAUSE_SLIDE_SHOW, CURRENT_SLIDE, CREATE_SUBSCRIBER, RESET_SUBSCRIBER, SLIDESHOW_SPINNER_VISIBILITY, SIGNUP_SPINNER_VISIBILITY, CURRENT_SONG, NEXT_SONG, ALLIMAGESLOADED } from '../actions/types';

const modalPayloadDefault = { isOpen: false, document: "my data here", description: " ", index: 0 };
const dropdownPayloadDefault = { selection: "Acorn woodpecker" };
const dropdownOpenPayloadDefault = { isOpen: false };
const currentSlidePayloadDefault = { currentSlide: -1 };
const nextSongDefault = { nextSong: -1 };
const currentFlickerPayloadDefault = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/" };
const pauseCallBackDefault = { pauseCallBack: null };
const subscriptionFoundPayloadDefault = { fetchSubscriptionAttempted: false, createNewSubscription: false, payload: {} };
const spinnerPayloadDefault = { slideshowSpinnerIsHidden: window.location.pathname === '/' ? false : true, signupSpinnerIsHidden: true };

const dropdownOptionsReducer = (state = dropdownOptions) => {
    return state;
};

const dropdownImagesReducer = (state = dropdownImages) => {
    return state;
};

const portfolioImagesReducer = (state = portfolioImages) => {
    return state;
};

//this runs one time to pick a random song to begin the sequence of songs with
const getRandomSong = (songsArray) => {
    //alert("getRandomSong should only happen once");
    const random = Math.random();
    return Math.floor(random * songsArray.length);
};
//this needs to set the random song to the next in sequence
const getNextSongReducer = (state = nextSongDefault, action) => {
    if (action.type === CURRENT_SONG || action.type === NEXT_SONG) {
        //alert("getCurrentSongReducer should only happen when toggling play music button");
        if (state.nextSong === nextSongDefault.nextSong) {
            return { ...state, nextSong: getRandomSong(action.payload) };
            //return { nextSong: getRandomSong(action.payload) }; also works
        }
    }
    if (action.type === NEXT_SONG) {
        //alert("getCurrentSongReducer should only happen when toggling play music button");
        let calculatedNextSong = state.nextSong + 1 === action.payload.length ? 0 : state.nextSong + 1;
        return { ...state, nextSong: calculatedNextSong };
        //return {  nextSong: calculatedNextSong }; also works
    }

    return state;
};


const slideshowImagesReducer = (state = slideshowImages, action) => {
    if (action.type === SLIDE_SHOW) {
        switch (action.payload.slideShow) {
            case '':
                state = slideshowImages;
                break;
            case '1':
                state = portfolioImages;
                break;
            case '2':
                state = egretFlightImages;
                break;
            case '3':
            case '3a':
                state = egretFamilyImages;
                break;
            case '4':
                state = egretCourtshipImages;
                break;
            case '5':
                state = egretChicksImages;
                break;
            case '6':
            case '6a':
            case '6b':
            case '6c':
                state = piedBilledGrebeImages;
                break;
            case '7':
                state = divingDucks1Images;
                break;
            case '8':
                state = divingDucks2Images;
                break;
            case '9':
                state = oddBuffleheadImages;
                break;
            case '10':
                state = floatingBuffleheadImages;
                break;
            case '11':
                state = flightBuffleheadImages;
                break;
            case '12':
                state = femaleBuffleheadImages;
                break;
            case '13':
                state = snowyEgretImages;
                break;
            case '14':
            case '14a':
            case '14b':
            case '14c':
                state = watchingRedTailedHawk;
                break;
            case '15':
            case '16':
                state = greatBlueHeron;
                break;
            case '17':
                state = cattleEgretImages;
                break;
            case '18':
                state = ringneckDucksEclipseImages;
                break;
            case '19':
                state = egretPreeningImages;
                break;
            case '20':
                state = scissortailedImages;
                break;
            case '21':
                state = houseFinchImages;
                break;
            case '22':
                state = mallardImages;
                break;
            case '23':
                state = coopersHawkImages;
                break;
            default:
                return state;
        }
    }
    return state;
};

//This is used to bring the flickr web site back to the proper page for the link that was clicked, but I have not been much worried about it
//I have a backup of the original code at D:\flickrappOriginalKeepAsBackup and it will work. So make sure never to overwrite that one. 

const fetchCurrentFlickerReducer = (state = currentFlickerPayloadDefault, action) => {
    if (action.type === SLIDE_SHOW) {
        switch (action.payload.slideShow) {
            case '1':
                state = currentFlickerPayloadDefault;
                break;
            case '2':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52401862741/" };
                break;
            case '3':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52713055122/" };
                break;
            case '3a':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52713970463/" };
                break;
            case '4':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52590116947/" };
                break;
            case '5':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52601615899/" };
                break;
            case '6':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52611854151/" };
                break;
            case '6a':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52612116879/" };
                break;
            case '6b':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52611854171/" };
                break;
            case '6c':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52611854176/" };
                break;
            case '7':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52620652789/" };
                break;
            case '8':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52622475944/" };
                break;
            case '9':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52624409858/" };
                break;
            case '10':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52623629677/" };
                break;
            case '11':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52632472739/" };
                break;
            case '12':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52629086706/" };
                break;
            case '13':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52632047468/" };
                break;
            case '14':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52727846183/" };
                break;
            case '14a':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/53520413756/" };
                break;
            case '14b':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/53520729189/" };
                break;
            case '14c':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/53520840305/" };
                break;
            case '15':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52820264659/" };
                break;
            case '16':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52676293449/" };
                break;
            case '17':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/50753004871/" };
                break;
            case '18':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52857707825/" };
                break;
            case '19':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52713055122/" };
                break;
            case '20':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52803765828/" };
                break;
            case '21':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/52948108486/" };
                break;
            case '22':
                state = { currentFlicker: "https://www.flickr.com/photos/30888088@N02/54477453573/" };
                break;
            default:
                return state;
        }
    }
    return state;
};

const fetchCurrentSlideReducer = (state = currentSlidePayloadDefault, action) => {
    if (action.type === CURRENT_SLIDE) {
        return { ...state, ...action.payload };
    }
    return state;
};

// const fetchpauseCallBackReducer = (state = pauseCallBackDefault, action) => {
//     if (action.type === CURRENT_INTERVAL_COUNTDOWN) {
//         return { ...state, ...action.payload };
//     }
//     return state;
// };


const fetchPauseSlideShowReducer = (state = pauseCallBackDefault, action) => {
    if (action.type === PAUSE_SLIDE_SHOW) {
        return { ...state, ...action.payload };
    }
    return state;
};


const modalReducer = (state = modalPayloadDefault, action) => {
    if (action.type === SHOW_MODAL) {
        return { ...state, ...action.payload };
    }
    return state;
};

const dropdownSelectionReducer = (state = dropdownPayloadDefault, action) => {
    if (action.type === DROPDOWN_SELECTION) {
        return { ...state, ...action.payload };
    }
    return state;
};

const dropdownOpenReducer = (state = dropdownOpenPayloadDefault, action) => {
    if (action.type === DROPDOWN_OPEN) {
        return { ...state, ...action.payload };
    }
    return state;
};


const setSpinnerVisibilityReducer = (state = spinnerPayloadDefault, action) => {
    if (action.type === SLIDESHOW_SPINNER_VISIBILITY) {
        return { ...state, ...action.payload }
    }
    if (action.type === SIGNUP_SPINNER_VISIBILITY) {
        return { ...state, ...action.payload }
    }
    return state;
};

const setAllImagesLoadedReducer = (state = false, action) => {
    if (action.type === ALLIMAGESLOADED) {
        return true;
    }
    return state;
};

const subscriberReducer = (state = subscriptionFoundPayloadDefault, action) => {
    switch (action.type) {
        case CREATE_SUBSCRIBER:
            return action.payload;
        case RESET_SUBSCRIBER:
            return subscriptionFoundPayloadDefault;
        default:
            return state;
    }
};


export default combineReducers({
    form: formReducer,
    portfolioImages: portfolioImagesReducer,
    dropdownImages: dropdownImagesReducer,
    dropdownOptions: dropdownOptionsReducer,
    slideshowImages: slideshowImagesReducer,
    modal: modalReducer,
    dropdownSelection: dropdownSelectionReducer,
    dropdownIsOpen: dropdownOpenReducer,
    //currentSlide: fetchCurrentSlideReducer,  //see my document ExplainingReducers.txt
    fetchCurrentSlideReducer,      // I like doing it this way better, you don't end up with code that looks like currentSlide.currentSlide out in the application
    fetchPauseSlideShowReducer,
    //fetchpauseCallBackReducer,
    fetchCurrentFlickerReducer,
    subscribers: subscriberReducer,
    getNextSongReducer,
    spinnerVisibility: setSpinnerVisibilityReducer,
    imagesLoaded: setAllImagesLoadedReducer
});



// import { combineReducers } from 'redux';

// export default combineReducers( {
//    replaceMe: () => 'replace this dummy reducer'
// });